import React, { Dispatch, SetStateAction } from 'react';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';
import { Divider, IconButton, Modal, Paper, Typography, Avatar } from '@material-ui/core';
import CheckIcon from '@mui/icons-material/Check';
import BlockIcon from '@mui/icons-material/Block';
import CloseIcon from '@mui/icons-material/Close';
import { legacyParse, convertTokens } from '@date-fns/upgrade/v2';

import VolunteerTime from 'entities/volunteerTime/model';
import { primaryBlue } from 'utils/color-styles';
import { convertDuration } from 'utils/convertDuration';
import { VolunteerTimeApproval } from 'generated/graphql';

const styles = {
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    padding: 16,
    width: 420,
  },
  divider: {
    margin: '16px 0',
  },
  approveBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: primaryBlue,
    borderRadius: 5,
    padding: '8px 20px',
    marginTop: 16,
  },
};

export const VolunteerTimeDetails = ({
  modalOpen,
  setModalOpen,
  volunteerTimeDetails,
  handleSubmit,
}: {
  modalOpen: boolean;
  setModalOpen: Dispatch<SetStateAction<boolean>>;
  volunteerTimeDetails?: VolunteerTime;
  handleSubmit: (
    newStatus: VolunteerTimeApproval.Approved | VolunteerTimeApproval.Rejected,
    ids?: string[]
  ) => void;
}) => {
  if (!volunteerTimeDetails) {
    return null;
  }

  return (
    <Modal
      open={modalOpen}
      onClose={() => setModalOpen(false)}
      style={styles.modal}
      disableAutoFocus
    >
      <Paper style={styles.paper}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
          }}
        >
          <div>
            <Avatar
              alt={`${volunteerTimeDetails.User.fullName?.first} ${volunteerTimeDetails.User.fullName?.last}`}
              src={volunteerTimeDetails.User?.mainPicture?.replace('http://', 'https://')}
              style={{
                width: 32,
                height: 32,
                float: 'left',
                marginRight: 10,
              }}
            />
            <div style={{ display: 'inline-block' }}>
              {volunteerTimeDetails.User.fullName?.first} {volunteerTimeDetails.User.fullName?.last}
              <Typography component="p" style={{ fontSize: 11 }}>
                <Link className="hoverable" to={`volunteers/${volunteerTimeDetails.User.id}`}>
                  View Profile
                </Link>
              </Typography>
            </div>
          </div>
          <CloseIcon style={{ cursor: 'pointer' }} onClick={() => setModalOpen(false)} />
        </div>
        <Divider style={styles.divider} />
        {!!volunteerTimeDetails.deed && (
          <Link
            to={`deeds/${volunteerTimeDetails.Deed.type?.toLowerCase()}s/${
              volunteerTimeDetails.Deed.id
            }`}
            className="hoverable"
            style={{ fontSize: 12, marginBottom: 16, display: 'block' }}
          >
            {volunteerTimeDetails.Deed.name}
          </Link>
        )}
        <div style={{ display: 'flex', marginBottom: 16 }}>
          <Typography component="p" style={{ fontSize: 12, fontWeight: 'bold', marginRight: 15 }}>
            Time Spent
          </Typography>
          <Typography component="p" style={{ fontSize: 12 }}>
            {!!volunteerTimeDetails.duration && convertDuration(volunteerTimeDetails.duration)}
          </Typography>
        </div>
        <div style={{ display: 'flex' }}>
          <Typography component="p" style={{ fontSize: 12, fontWeight: 'bold', marginRight: 55 }}>
            Date
          </Typography>
          <Typography component="p" style={{ fontSize: 12 }}>
            {format(legacyParse(volunteerTimeDetails.date), convertTokens('DD/MM/YYYY'))}
          </Typography>
        </div>
        {volunteerTimeDetails.notes && (
          <>
            <Divider style={styles.divider} />
            <Typography
              component="p"
              style={{ fontSize: 12, fontWeight: 'bold', marginBottom: 16 }}
            >
              Note:
            </Typography>
            <Typography component="p" style={{ fontSize: 12, lineHeight: '22px' }}>
              {volunteerTimeDetails.notes}
            </Typography>
          </>
        )}
        <div style={styles.approveBar}>
          <Typography component="p" style={{ fontSize: 12, lineHeight: '22px', color: 'white' }}>
            Approve / Deny
          </Typography>
          <div>
            <>
              <IconButton
                title="Approve"
                onClick={() => {
                  handleSubmit(VolunteerTimeApproval.Approved, [volunteerTimeDetails.id]);
                  setModalOpen(false);
                }}
                style={{ color: 'white' }}
              >
                <CheckIcon />
              </IconButton>
              <IconButton
                title="Deny"
                onClick={() => {
                  handleSubmit(VolunteerTimeApproval.Rejected, [volunteerTimeDetails.id]);
                  setModalOpen(false);
                }}
              >
                <BlockIcon style={{ color: 'white' }} />
              </IconButton>
            </>
          </div>
        </div>
      </Paper>
    </Modal>
  );
};
